import { Component, Input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-copy-to-clipboard-button',
  template: `
    <div [class.d-flex]="showIdWithButton" [class.align-items-center]="showIdWithButton">
      @if (showIdWithButton) {
      <span class="me-2" [title]="value">{{ displayValue }}</span>
      }
      <button
        type="button"
        class="btn copy-btn btn-outline-primary df-btn-icononly df-btn-tertiary"
        [class.processing]="isProcessing"
        [disabled]="!value"
        (click)="copyToClipboard()"
        [attr.aria-label]="ariaLabel"
        i18n-aria-label="@@upp.global.button.copyToClipboard"
        ngbTooltip="Copy to clipboard"
        i18n-ngbTooltip="@@upp.global.button.copyToClipboard"
        container="body"
        triggers="hover"
        autoClose="true"
      >
        <span id="copyIcon" [class]="iconClass"></span>
      </button>
    </div>
  `,
  styles: [
    `
      .copy-btn {
        padding: 0.25rem 0.5rem;
        border: none;
        background: transparent;
        cursor: pointer;
      }
      .copy-btn:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.05);
      }
      .copy-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
      .copy-btn.processing {
        pointer-events: none;
      }
      #copyIcon {
        transition: opacity 0.3s;
      }
      #copyIcon::before {
        margin-right: 0;
      }
      .processing #copyIcon {
        animation: copy-animation 1s ease;
      }
      @keyframes copy-animation {
        0% {
          opacity: 1;
        }
        20% {
          opacity: 0;
        }
        40% {
          opacity: 1;
        }
        80% {
          opacity: 1;
        }
        100% {
          opacity: 1;
        }
      }
    `
  ],
  standalone: true,
  imports: [NgbTooltip]
})
export class CopyToClipboardButtonComponent implements ICellRendererAngularComp {
  @Input() value = '';
  @Input() ariaLabel = 'Copy to clipboard';
  @Input() showIdWithButton = false;
  @Input() truncateLength = 15;

  displayValue = '';
  isProcessing = false;
  iconClass = 'fa-light fa-copy';

  agInit(params: ICellRendererParams): void {
    this.value = params.value ?? '';
    this.showIdWithButton = true;
    this.updateDisplayValue();
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }

  private updateDisplayValue(): void {
    this.displayValue =
      this.value.length > this.truncateLength ? `${this.value.substring(0, this.truncateLength)}...` : this.value;
  }

  async copyToClipboard(): Promise<void> {
    if (this.isProcessing || !this.value) {
      return;
    }

    this.isProcessing = true;
    try {
      await navigator.clipboard.writeText(this.value);
      this.iconClass = 'fa-light fa-check text-success';
    } catch (_error) {
      this.iconClass = 'fa-light fa-times text-danger';
    }

    setTimeout(() => {
      this.isProcessing = false;
      this.iconClass = 'fa-light fa-copy';
    }, 1000);
  }
}
